module.exports = __webpack_public_path__ + "static/media/b4-black-english.921ae725.png";